import PropTypes from 'prop-types';

const propType = {
  min: PropTypes.number,
  max: PropTypes.number,
  currency: PropTypes.string,
  symbol: PropTypes.string,
};

export default { propType };
